import { MutableRefObject, useRef, useState } from 'react';

// source: https://css-tricks.com/dealing-with-stale-props-and-states-in-reacts-functional-components/

export const useAsyncReference = <S>(value: S) => {
    const ref = useRef(value);
    const [, forceRender] = useState(false);

    const updateState = (newState: S) => {
        ref.current = newState;
        forceRender(s => !s);
    };

    return [ref, updateState] as [MutableRefObject<S>, (newState: S) => void];
};



// WEBPACK FOOTER //
// ./src/hooks/useAsyncReference.ts